import store from '@/store';
import { Module, VuexModule, Action, Mutation, getModule } from 'vuex-module-decorators';

interface IApplicationBarState {
    Title: string
}

@Module({ namespaced: true, name: 'application-bar', dynamic: true, store })
class ApplicationBarState extends VuexModule implements IApplicationBarState {
    Title: string = '';

    @Action({ rawError: true })
    public changeTitle(title: string) : void {
        this.setTitle(title);
    }

    @Mutation
    public setTitle(title: string) : void {
        this.Title = title;
    }
}

const applicationBarModule = getModule(ApplicationBarState);
export default applicationBarModule;